import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieOptions, CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

const cookieConfig: CookieOptions = {
  path: '/',
  sameSite: 'Lax',
  domain: environment.dev ? '' : environment.cookieDomain,
};

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public title = 'scattre-canvas';

  constructor(
    private cookie: CookieService,
    private cd: ChangeDetectorRef,
  ) {
    this.cookie.set('_yn', '2026', cookieConfig);
    this.cookie.set('_mo', '8', cookieConfig);
    this.cookie.set('_dp', '2', cookieConfig);
    this.cookie.set('_sa', '456982092397', cookieConfig);
    this.cookie.set('_lm', '301996468375', cookieConfig);
    this.cookie.set('_uy', '15420372833.571428', cookieConfig);
    if (!this.theme) this.theme = 'dark';

    if (this.theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }
  get theme(): 'light' | 'dark' | undefined {
    return this.cookie.get('theme') as 'light' | 'dark';
  }

  set theme(value: 'light' | 'dark') {
    this.cookie.set('theme', value, cookieConfig);
    if (value === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }
  ngOnInit() {}
}
